import { Component, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { NewSimulationService } from '../new-simulation.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-product-information',
    templateUrl: './product-information.component.html',
    styleUrls: ['./product-information.component.css']
})
export class ProductInformationComponent implements OnInit {

    public productInformationForm = this.productInformationForm = this.formBuilder.group({
        array: this.formBuilder.array([])
    });

    private section;

    public data;

    constructor(private formBuilder: FormBuilder, private service: NewSimulationService, private router: Router) {
        this.section = this.service.sections[0];
    }

    ngOnInit() {
        if (this.section.data && this.section.data.length > 0) {
            for (const d of this.section.data) {
                this.addNewProductInfo(d);
            }
        } else {
            this.addNewProductInfo();
        }
    }

    private getNewFormItem(productInfo: ProductInfoEntity = null): FormGroup {

        let formGroup: FormGroup;

        if (productInfo) {
            formGroup = this.formBuilder.group({
                brandName: [productInfo.brandName, Validators.required],
                otherBrand: [productInfo.otherBrand],
                activeIngredients: [productInfo.activeIngredients, Validators.required],
                atcCode: [productInfo.ATCCode],
                strength: this.formBuilder.group({
                    value: [productInfo.strengthValue, Validators.required],
                    unit: [productInfo.strengthUnit, Validators.required]
                }),
                packSize: [productInfo.packSize],
                form: [productInfo.form],
                sim_type: [productInfo.sim_type]
            });
        } else {

            this.section.data.push(new ProductInfoEntity());

            formGroup = this.formBuilder.group({
                brandName: ['', Validators.required],
                otherBrand: [''],
                activeIngredients: ['', Validators.required],
                atcCode: ['', Validators.required],
                strength: this.formBuilder.group({
                    value: ['', Validators.required],
                    unit: ['', Validators.required]
                }),
                packSize: ['', Validators.required],
                form: ['', Validators.required],
                sim_type: ['', Validators.required]
            });
        }


        return formGroup;

    }

    onNextClicked() {
        this.section.completed = true;
        if (this.section.data[0].sim_type == 'MEA') {
            this.router.navigate(['/new-simulation/mea-selection']);
        } else {
            this.router.navigate(['/new-simulation/tender-selection']);
        }  
    }

    onAddNewClicked() {
        this.addNewProductInfo();
    }

    onDeleteClicked(index) {
        const formArray: FormArray = <FormArray>this.productInformationForm.controls['array'];
        formArray.removeAt(index);
        this.section.data.splice(index, 1);
    }

    private addNewProductInfo(productInfo: ProductInfoEntity = null) {
        const formArray: FormArray = <FormArray>this.productInformationForm.controls['array'];
        formArray.push(this.getNewFormItem(productInfo));
    }

    public onProductChange(product) {

        const that = this;

        if (product !== 'other') {
            this.service.fetchMedicineDetails(product)
                .subscribe((result => {

                    that.section.data[0]['activeIngredients'] = result['ingredients_0'];
                    that.section.data[0]['ATCCode'] = result['atc_code_0'];
                    that.section.data[0]['strengthValue'] = result['strength_0'];
                    that.section.data[0]['strengthUnit'] = result['unit_0'];
                    that.section.data[0]['packSize'] = result['pack_size_0'][0];
                    that.section.data[0]['form'] = result['form_0'];
                    that.section.data[0]['sim_type'] = 'Tender';

                }));
        } else {
            // this.productInformationForm.controls['array'][0].controls
            that.section.data[0]['activeIngredients'] = '';
            that.section.data[0]['ATCCode'] = '';
            that.section.data[0]['strengthValue'] = '';
            that.section.data[0]['strengthUnit'] = '';
            that.section.data[0]['packSize'] = '';
            that.section.data[0]['form'] = '';
            that.section.data[0]['sim_type'] = '';
        }
    }

}

export class ProductInfoEntity {
    public brandName: string;
    public otherBrand: string;
    public activeIngredients: string;
    public ATCCode: string;
    public strengthValue: string;
    public strengthUnit: string;
    public packSize: string;
    public form: string;
    public sim_type: string;

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/product-information/product-information.component.ts